import { Link } from "react-router-dom";
import Icon from "../Icon/Icon";

export default function Breadcrumbs({ listName }) {
    return (
        <div className="max-w-3xl mx-auto">
            <nav className="text-sm mb-4" aria-label="Breadcrumb">
                <ol className="flex items-center space-x-2 mb-2">
                    {/* Home / Lists link */}
                    <li>
                        <Link
                            to="/lists"
                            className="text-text-dark font-medium text-md"
                        >
                            Lists
                        </Link>
                    </li>

                    {/* Separator */}
                    <li>
                        <span className="text-text-dark text-sm"><Icon icon="chevronRight" /></span>
                    </li>

                    {/* Current page */}
                    <li aria-current="page" className="text-text-dark font-semibold text-md truncate max-w-xs">
                        {listName}
                    </li>
                </ol>
            </nav>
        </div>
    );
}
